import { Star } from "lucide-react";
import { useReveal } from "../../lib/animations";
import { useHomepageContent } from "@/lib/homepageContent";

// Visual-only avatar images zipped onto the editable testimonials by index.
const testimonialAvatars = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
];

export default function Testimonials() {
  const ref = useReveal();
  const { testimonials: content } = useHomepageContent();
  const testimonials = content.items.map((t, i) => ({ ...t, avatar: testimonialAvatars[i] }));
  return (
    <section data-testid="testimonials" className="oc-section bg-oc-bg">
      <div ref={ref} className="oc-reveal oc-container">
        <div className="max-w-3xl">
          <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">
            {content.eyebrow}
          </span>
          <h2 className="font-display font-bold text-[28px] sm:text-[36px] lg:text-[42px] leading-tight tracking-tight text-oc-primary mt-3 whitespace-normal lg:whitespace-nowrap">
            {content.heading}
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i + 1}`}
              className="bg-white rounded-oc border border-oc-border p-9 transition-all hover:-translate-y-1 hover:shadow-oc-card-hover"
              style={{ animation: `fade-in-up 600ms ease-out both ${i * 100}ms` }}
            >
              <div className="flex gap-1">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <blockquote className="mt-5 text-oc-textPrimary text-[16px] leading-[1.7]">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-oc-border" />
                <div>
                  <p className="font-display font-semibold text-oc-primary text-[15px]">{t.name}</p>
                  <p className="text-oc-textSecondary text-[13px]">{t.location}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
